<template>
	<div class="begin">
		<el-dialog :title="title" width="540px" :visible.sync="dialogBeginVisible" @close="resetForms('beginFrom')" :destroy-on-close="true">
			<div style="max-height: 430px; overflow-y: scroll">
				<div class="tipsBox">
					<tips-box></tips-box>
				</div>
				<div class="mt-24">
					<product-box :row="row" :tabName="tabName" :is_good_type="is_good_type"></product-box>
				</div>
				<div class="mt-20">
					<user-info-box :row="row"></user-info-box>
				</div>
				<div class="mt-20 form-content">
					<el-form :model="beginFrom" ref="beginFrom" :rules="radio === 2 ? video_url_ruels : unlimit_ruels">
						<el-form-item label="带货类型：" :label-width="formLabelWidth" prop="sell_goods_type" v-if="state === 1 || state === 4">
							<el-radio-group v-model="radio" @change="switchFun">
								<el-radio :label="0">不限</el-radio>
								<el-radio :label="1">直播</el-radio>
								<el-radio :label="2">短视频</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="开始合作时间：" :label-width="formLabelWidth" prop="start_time" v-if="(state === 1 || state === 4) && radio !== 2">
							<el-date-picker
								v-model="timesTamp"
								type="datetime"
								@change="changeTimed"
								value-format="timestamp"
								placeholder="选择开始合作时间"
							></el-date-picker>
						</el-form-item>
						<el-form-item label="短视频链接：" :label-width="formLabelWidth" prop="video_url" v-if="(state === 1 || state === 4) && radio !== 1">
							<el-input type="textarea" :rows="2" placeholder="请输入短视频链接" v-model="beginFrom.video_url"></el-input>
						</el-form-item>
						<el-form-item label="预计带货时间：" :label-width="formLabelWidth" prop="begin_time" v-if="state === 2 || state === 3">
							<el-date-picker
								style="width: 320px"
								v-model="timesTamp"
								@change="changeTimed"
								value-format="timestamp"
								type="datetime"
								placeholder="选择带货时间"
							></el-date-picker>
						</el-form-item>
						<el-form-item label="带货截图：" :label-width="formLabelWidth" prop="image_list">
							<uploadImg
								@saveCardLink="saveCardLink"
								ref="uploadImg"
								:default_img_list="beginFrom.image_list"
								:limit="99"
								:multiple="true"
							></uploadImg>
						</el-form-item>
					</el-form>
					<p class="fz-12 content" v-if="state === 1 || state === 4">{{ content }}</p>
					<p class="fz-12 ml-10" v-if="state === 3">无样开播将跳过申样阶段，直接进入【合作进度-待播表】中。</p>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogBeginVisible = false">取 消</el-button>
				<el-button type="primary" @click="beginConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import tipsBox from '@/components/common/tipsBox';
import uploadImg from '@/components/common/uploadImg';
import { OrderAffirm, confirmLive, nosampleLive, getDeliveryAuditDetail, deliveryAuditEdit } from '@/api/cooperationProgress';
export default {
	components: {
		productBox,
		userInfoBox,
		tipsBox,
		uploadImg,
	},
	name: 'begin',
	computed: {
		content() {
			return this.radio === 0
				? '带货方式为“不限”，任意填入开播时间或短视频链接后，流转到开播表，系统将根据“开播时间”或“短视频的发布时间”统计该达人对该商品的带货数据。'
				: this.radio === 1
				? '带货方式为“直播”，系统将根据“开播时间”统计该达人对该商品带货数据'
				: '带货方式为“短视频”，系统将根据“短视频发布时间”统计该达人对该商品的带货数据';
		},
	},
	data() {
		return {
			dialogBeginVisible: false,
			beginFrom: {
				sell_goods_type: 0,
				start_time: '',
				begin_time: '',
				video_url: '',
				image_list: [],
			},
			unlimit_ruels: {
				start_time: [{ required: true, message: '请填写开始合作时间', trigger: 'blur' }],
				begin_time: [{ required: true, message: '请填写预计开播时间', trigger: 'blur' }],
			},
			video_url_ruels: {
				begin_time: [{ required: true, message: '请填写预计开播时间', trigger: 'blur' }],
				video_url: [{ required: true, message: '请填写短视频链接', trigger: 'blur' }],
			},
			formLabelWidth: '130px',
			datePicker: '',
			state: 0,
			title: '',
			row: {},
			timesTamp: '',
			tabName: '',
			radio: 0,
			is_good_type: 0,
		};
	},
	methods: {
		saveCardLink(val) {
			this.beginFrom.image_list = [...val];
		},
		async initBeginFun(row, state, tabName) {
			this.tabName = tabName;
			this.timesTamp = '';
			this.radio = Number(row.sell_goods_type);
			this.state = state;
			this.row = row;
			this.is_good_type = 0;
			this.reset();
			this.dialogBeginVisible = true;
			if (state === 1) {
				this.timesTamp = row.estimate_time && row.estimate_time != 0 ? row.estimate_time * 1000 : '';
				this.beginFrom.start_time = row.estimate_time;
				this.beginFrom.sell_goods_type = this.radio;
				this.is_good_type = 1;
				this.title = '确认开播';
				// 增加重新提交 === 编辑
			} else if (state === 2) {
				this.is_good_type = 1;
				this.title = '确认带货';
			} else if (state === 3) {
				this.title = '无样开播';
			} else if (state === 4) {
				this.getDetail();
				this.title = '确认开播';
			}
			this.state = state;
		},
		getDetail() {
			getDeliveryAuditDetail({
				cooperate_id: this.row.cooperate_id,
			}).then(res => {
				this.$refs.uploadImg.clearFiles();
				let info = res.data;
				info.image_list = info.image_list?.length ? info.image_list.map(item => item.image_url) : [];
				info.start_time = info.live_time;
				this.$refs.uploadImg.setImgs(info.image_list);
				this.beginFrom = info;
				this.radio = info.sell_goods_type;
				this.timesTamp = info.live_time * 1000;
			});
		},
		beginConfirm() {
			if (this.state === 1 || this.state === 4) {
				this.$refs.beginFrom.validate(async valid => {
					if (valid) {
						let params = {
							cooperate_id: this.row.cooperate_id,
							live_time: this.beginFrom.start_time,
							sell_goods_type: this.beginFrom.sell_goods_type,
							video_url: this.beginFrom.sell_goods_type == 1 ? undefined : this.beginFrom.video_url,
							image_list: this.beginFrom.image_list,
						};

						let res = this.state === 1 ? await confirmLive(params) : await deliveryAuditEdit(params);

						if (res.code == 0) {
							this.$message.success('操作成功');
							this.$emit('refreshList');
							this.dialogBeginVisible = false;
						}
					}
				});
			} else if (this.state === 2) {
				this.$refs.beginFrom.validate(async valid => {
					if (valid) {
						let params = {
							cooperate_id: this.row.cooperate_id,
							live_time: this.beginFrom.begin_time,
							sample_sn: this.row.sample_sn,
						};
						const { code } = await OrderAffirm(params);
						if (code == 0) {
							this.$message.success('操作成功');
							this.$emit('refreshList');
							this.dialogBeginVisible = false;
						}
					}
				});
			} else if (this.state === 3) {
				this.$refs.beginFrom.validate(async valid => {
					if (valid) {
						let params = {
							cooperate_id: this.row.cooperate_id,
							estimate_time: this.beginFrom.begin_time,
						};
						const { code } = await nosampleLive(params);
						if (code == 0) {
							this.$message.success('操作成功');
							this.$emit('refreshList');
							this.dialogBeginVisible = false;
						}
					}
				});
			}
		},
		async switchFun(e) {
			this.$refs['beginFrom'].clearValidate();
			this.beginFrom.sell_goods_type = e;
		},
		reset() {
			this.beginFrom = {
				sell_goods_type: 0,
				start_time: '',
				begin_time: '',
				video_url: '',
				image_list: [],
			};
		},
		//重置弹框表单
		resetForms(from) {
			this.timesTamp = '';
			this.reset();
			this.$refs[from].resetFields();
		},
		changeTimed(val) {
			this.beginFrom.begin_time = val ? val / 1000 : 0;
			this.beginFrom.start_time = val ? val / 1000 : 0;
		},
	},
};
</script>
<style lang="less" scoped>
.tips {
	background: #fef3e7;
	border: 1px solid #fba543;
	padding: 11px 16px;
}
.content {
	line-height: 20px;
}
.begin {
	/deep/ .el-dialog__body {
		padding: 10px 24px 24px 24px !important;
	}
}
.form-content {
	.el-form {
		border-radius: 8px;
		padding: 16px 16px 0 16px;
		background: #f7f8f9;
		/deep/ .el-form-item__label {
			color: @color-gy9;
		}
		/deep/ .el-form-item {
			margin-bottom: 0px !important;
			padding-bottom: 16px;
		}
	}
}
</style>
